import { Link, useNavigate } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const handleContactScroll = () => {
    const el = document.querySelector("#contact");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const target = document.querySelector("#contact");
        if (target) target.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  };

  return (
    <footer className="bg-[#080808] border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1 – Brand */}
          <div>
            <div className="mb-4">
              <Link to="/" className="cursor-pointer">
                <span className="font-serif text-white text-xl font-bold tracking-widest uppercase block">
                  Don Collins
                </span>
                <span className="font-sans text-gold text-xs tracking-[0.25em] uppercase font-medium">
                  Auto Storage
                </span>
              </Link>
            </div>
            <p className="font-sans text-sm text-[#9A9A9A] leading-relaxed">
              Secure, fully-alarmed indoor vehicle storage for collectors and owners of cars, motorcycles, RVs, boats and specialty vehicles — serving the Bay Area since 1961.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="mailto:doncollinsstorage@gmail.com"
                aria-label="Email"
                className="w-8 h-8 flex items-center justify-center text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer"
              >
                <i className="ri-mail-fill text-lg"></i>
              </a>
              <a
                href="https://www.google.com/maps/search/Don+Collins+Auto+Storage+San+Rafael+CA"
                target="_blank"
                rel="nofollow noopener"
                aria-label="Google Maps"
                className="w-8 h-8 flex items-center justify-center text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer"
              >
                <i className="ri-map-pin-2-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Column 2 – Quick Links */}
          <div>
            <h4 className="font-sans text-gold text-xs tracking-[0.2em] uppercase font-semibold mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
                  Storage Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/location" className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
                  Locations
                </Link>
              </li>
              <li>
                <button
                  onClick={handleContactScroll}
                  className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 – Services */}
          <div>
            <h4 className="font-sans text-gold text-xs tracking-[0.2em] uppercase font-semibold mb-5">
              Storage Services
            </h4>
            <ul className="space-y-3">
              {[
                "Indoor Car Storage",
                "Classic & Collector Cars",
                "Motorcycle Storage",
                "RV & Boat Storage",
                "Truck & Equipment Storage",
                "Motorcycle Road Service",
              ].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 – Contact */}
          <div id="contact-footer">
            <h4 className="font-sans text-gold text-xs tracking-[0.2em] uppercase font-semibold mb-5">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 text-gold flex-shrink-0">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <span className="font-sans text-sm text-[#9A9A9A] leading-relaxed">
                  Irwin St, San Rafael, CA
                  <br />
                  Canal Blvd, Point Richmond, CA
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                <a
                  href="tel:4154539180"
                  className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer"
                >
                  (415) 453-9180 — Office
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0">
                  <i className="ri-smartphone-line text-sm"></i>
                </div>
                <a
                  href="tel:4158464281"
                  className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer"
                >
                  (415) 846-4281 — Cell / Jim Long
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <a
                  href="mailto:doncollinsstorage@gmail.com"
                  className="font-sans text-sm text-[#9A9A9A] hover:text-gold transition-colors cursor-pointer"
                >
                  doncollinsstorage@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 text-gold flex-shrink-0">
                  <i className="ri-time-line text-sm"></i>
                </div>
                <span className="font-sans text-sm text-[#9A9A9A]">
                  Open Daily — By Appointment
                  <br />
                  <span className="text-xs text-[#666]">Please call first</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5 px-6 lg:px-10 py-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-[#555] text-center md:text-left">
            &copy; {currentYear} Don Collins Auto Storage. All rights reserved. Operated by Jim Long.
          </p>
          <p className="font-sans text-xs text-[#555]">
            Secure indoor vehicle storage — San Rafael &amp; Point Richmond, CA
          </p>
        </div>
      </div>

      {/* Big Brand Name */}
      <div className="overflow-hidden px-6 lg:px-10 pb-6">
        <p className="font-serif text-[7vw] font-bold tracking-tighter text-[#1A1A1A] leading-none select-none text-center uppercase">
          Don Collins
        </p>
      </div>
    </footer>
  );
}
